import { Field, FieldProps } from 'formik'
import { FormikFieldProps } from './FieldProps'
import PerRatingRadioGroup, { RatingRadioGroupProps } from '../custom_components/RatingRadioGroup'

type RatingRadioButtonsProps = FormikFieldProps & RatingRadioGroupProps & { [key: string]: unknown }

const FormikRatingRadioGroup = ({ name, validate, maxRating, onChange, ...props }: RatingRadioButtonsProps): JSX.Element => {
  return (
    <Field name={name} validate={validate}>
      {({ field: { value }, form: { setFieldValue } }: FieldProps) => (
        <PerRatingRadioGroup
          name={name}
          value={value}
          maxRating={maxRating}
          onChange={(e) => {
            const v = e.target.value
            setFieldValue(name, !isNaN(v) ? v : '')
            onChange && onChange(e)
          }}
          {...props}
        />
      )}
    </Field>
  )
}

export default FormikRatingRadioGroup
